export default "__VITE_ASSET__benXm4O9__"